const RESERVED_PROFILE_PATH_SEGMENTS = new Set([
  "feed",
  "search",
  "saved",
  "offers",
  "my-listings",
  "orders-placed",
  "order-management",
  "orders",
  "profile",
  "settings",
  "shipping-settings",
  "terms",
  "privacy",
  "contact",
  "mission",
  "changelog",
  "poll",
  "contest",
  "contest-results",
  "analytics",
  "label-creation",
  "admin",
  "chat",
  "api",
]);

export function isPublicProfilePath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length !== 1) return false;
  return !RESERVED_PROFILE_PATH_SEGMENTS.has(parts[0]);
}
